import React from 'react';
import { SendMoneyFeesContainer } from './style';
import { SEND_MONEY_CALCULATOR_SCREEN } from '../../../utils/constants';
import { formatCurrencyAmount } from '@Utils/library';

interface IIncludedFees {
  txnFees: number;
  sourceCurrency: string;
  bankTransferFee: number;
  rcvFees: number;
}
const IncludedFees: React.FC<IIncludedFees> = (props) => {
  const { txnFees = 0, bankTransferFee = 0, rcvFees = 0, sourceCurrency } = props;
  const { transactionFees, bankTransferLabel, receivingMethodFee } = SEND_MONEY_CALCULATOR_SCREEN;
  return (
    <div>
      <SendMoneyFeesContainer>
        <div className="label">{transactionFees}</div>
        <div className="value">{`${formatCurrencyAmount(txnFees)} ${sourceCurrency}`}</div>
      </SendMoneyFeesContainer>
      <SendMoneyFeesContainer>
        <div className="label">{bankTransferLabel}</div>
        <div className="value">{`${formatCurrencyAmount(bankTransferFee)} ${sourceCurrency}`}</div>
      </SendMoneyFeesContainer>
      <SendMoneyFeesContainer>
        <div className="label">{receivingMethodFee}</div>
        <div className="value">{`${formatCurrencyAmount(rcvFees)} ${sourceCurrency}`}</div>
      </SendMoneyFeesContainer>
    </div>
  );
};

export default IncludedFees;
